import { createClient } from '@shared/api-client/createClient';
import keycloak from '@/feature/auth/keycloak';
import { getBuild, version } from '@/feature/build';
import { appInsights } from '@/feature/insights/appInsights';
import { getRequestLanguage } from '@/feature/lang/util';
import {
  captureException,
  captureHttpError,
  captureResponseParseError,
  withScope,
} from '@/feature/sentry';
import { isDev } from '@/util/env';

export const apiClient = createClient({
  headers: () => ({
    'Accept-Language': getRequestLanguage(),
    ...(keycloak.token && { Authorization: `Bearer ${keycloak.token}` }),
    'sandvik-user-agent': `SamWeb/${version}-${getBuild().number}`,
  }),
  onUnauthorized: () => keycloak.logout(),
  onError: captureHttpError,
  onParseError: captureResponseParseError,
  onValidationError: (error, { path, data }) => {
    const firstIssueMessage = error.issues.at(0)?.message;
    const exception = new Error(`Incorrect data: ${firstIssueMessage}`);
    exception.cause = error;
    appInsights.trackException({
      exception,
      properties: { path, data, error },
    });
    withScope((scope) => {
      scope.setTag('validation', 'zod');
      scope.setExtra('issues', error.issues);
      scope.setExtra('input', data);
      captureException(error);
    });
  },
  logLevel: isDev ? 'debug' : 'silent',
});

export const v1 = apiClient.scope('/api/v1');
export const v2 = apiClient.scope('/api/v2');
export const v3 = apiClient.scope('/api/v3');
